export default "__VITE_ASSET__B0n5C$CP__"